<sf-filter (searchFired)="search()" (resetFired)="reset()" [isCollapsed]="true" [isCollapsable]="true">
    <form [formGroup]="filterForm">
        <div class="row">
            <div class="col-lg-8">
                <div class="row">
                    <div class="col-md-4 col-xl-3">
                        <sf-input-customer
                            label="Customer"
                            formControlName="customerId"
                            (selectedCustomerChanged)="search()"></sf-input-customer>
                    </div>
                    <div class="col-md-4 col-xl-3">
                        <sf-label for="statusSelect" label="Status"></sf-label>
                        <ng-select
                            id="statusSelect"
                            [clearable]="false"
                            [items]="statusOptions"
                            bindLabel="label"
                            bindValue="value"
                            formControlName="status"></ng-select>
                    </div>
                    <div class="col-md-4 col-xl-3">
                        <sf-input
                            label="Job Details"
                            inputId="searchTerm"
                            placeholder="Search description and notes"
                            formControlName="searchTerm"></sf-input>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <sf-calendar-range-selector formControlName="dateRangeFilter"></sf-calendar-range-selector>
            </div>
        </div>
    </form>
</sf-filter>
